import React from 'react'
import './SearchFormCondensed.scss'

import pencilIcon from './edit.svg'

const SearchFormCondensed = ({ searchValues, onEdit, lexicon }) => {
  return (
    // TODO: eslint (react/button-has-type): should this submit a form? then button="submit", else button="button"
    // eslint-disable-next-line react/button-has-type
    <button className="SearchFormCondensed" onClick={onEdit}>
      {searchValues.map((value) => (
        <div key={value}>{value}</div>
      ))}
      <div className="edit-search">
        <img src={pencilIcon} alt="edit" />
        <span>{lexicon.get('edit_search')}</span>
      </div>
    </button>
  )
}

export default SearchFormCondensed
